import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* changeEmailConfirm(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_REQUEST
    });

    yield call(Http.post, `auth/email-change-confirm?token=${action.payload?.token}`);

    yield put({
      type: Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-action-successful"),
        type: "success"
      }
    });

  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChangeEmailConfirm() {
  yield takeEvery(Constants.PAGE_SETTINGS_USER_PROFILE_CHANGE_EMAIL_CONFIRM_START, changeEmailConfirm);
}
